import { cssWideKeywords } from '../../lexer/generic-const.js';
import definitions from '../../data.js';
import * as node from '../node/index.js';

export default {
    generic: true,
    cssWideKeywords,
    ...definitions,
    node
};
